import { Icon, Typography } from '@scale/scaleui';
import _ from 'lodash';
import { LoadingStatisticCard, StatisticCard, StatisticCardProps } from './StatisticCard';

interface StatisticRowProps {
  title?: string;
  cards: StatisticCardProps[];
  loadingCards?: number;
}

export const StatisticRow: React.FC<StatisticRowProps> = ({
  title,
  cards,
  loadingCards = 0,
}: StatisticRowProps) => {
  return (
    <div>
      <div className="p-4 border border-neutral-200 bg-neutral-0 rounded-md">
        <div className="flex flex-row items-center bg-netural-300 mb-4 gap-2">
          <Icon
            icon={['far', 'globe']}
            variant="neutral"
            className="bg-neutral-100 rounded-md"
            hasBackground
          />
          <Typography.Subtitle2>{title}</Typography.Subtitle2>
        </div>
        <div className="flex gap-2 flex-wrap">
          {cards.map(card => (
            <StatisticCard key={card.title + card.subtitle} {...card} />
          ))}
          {_.range(loadingCards).map(index => (
            <LoadingStatisticCard key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};
